import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhLabelComponent } from '@shared/components/ph-label/ph-label.component';

@NgModule({
  declarations: [PhLabelComponent],
  exports: [PhLabelComponent],
  imports: [CommonModule],
})
export class PhLabelModule {}
